import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { LogoTicker } from './components/LogoTicker';
import { PortfolioGrid } from './components/PortfolioGrid';
import { ClientLogosAngled } from './components/ClientLogosAngled';
import { ServicesTimeline } from './components/ServicesTimeline';
import { Footer } from './components/Footer';
import { ScriptLoader } from './components/ScriptLoader';
const HomePage = () => {
  return <>
      <main data-id="element-0">
        <Hero data-id="element-1" />
        <LogoTicker data-id="element-2" />
        <PortfolioGrid data-id="element-3" />
        <ClientLogosAngled data-id="element-4" />
        <ServicesTimeline data-id="element-5" />
      </main>
    </>;
};
export function App() {
  return <div className="min-h-screen bg-[#FAF7F2]" data-id="element-6">
      <ScriptLoader data-id="element-7" />
      <Header data-id="element-8" />
      <HomePage data-id="element-9" />
      <Footer data-id="element-10" />
    </div>;
}